import script from "./PastPapers.vue?vue&type=script&setup=true&lang=js"
export * from "./PastPapers.vue?vue&type=script&setup=true&lang=js"

import "./PastPapers.vue?vue&type=style&index=0&id=3796bcf3&scoped=true&lang=css"
import "./PastPapers.vue?vue&type=style&index=1&id=3796bcf3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3796bcf3"]])

export default __exports__